/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_TitleInputs */

const en_dr_pick_title = /** @type {(inputs: Dr_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which workspace should the room live in?`)
};

const id_dr_pick_title = /** @type {(inputs: Dr_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang ini mau ditaruh di workspace mana?`)
};

/**
* | output |
* | --- |
* | "Which workspace should the room live in?" |
*
* @param {Dr_Pick_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_title = /** @type {((inputs?: Dr_Pick_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_title(inputs)
	return en_dr_pick_title(inputs)
});